import { useState } from 'react'
import { isEmpty } from 'lodash'
import cn from 'classnames'

import { ReactComponent as IconArrowDown } from 'assets/icons/IconArrowDown.svg'

const Accordion = ({ header, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="accordion">
      <div className="accordion__header-wrapper">
        <h3 className="accordion__header">{header}</h3>
        <button
          type="button"
          className={cn('accordion__button', { '-isOpen': isOpen })}
          onClick={() => setIsOpen(!isOpen)}
        >
          <IconArrowDown />
        </button>
      </div>
      {
        <div
          className={cn('accordion__body', {
            '-isOpen': isOpen,
            '-isEmpty': isEmpty(children),
          })}
        >
          {children}
        </div>
      }
    </div>
  )
}

export default Accordion
